import { Component, OnInit } from '@angular/core';
import { ParamMap } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { GetEmpty } from 'src/app/classes/Empties';
import { Ecommerce, Price_List, Price_Type, Store } from 'src/app/models/RestModels';
import { BaseComponent } from '../base/base.component';

@Component({
	selector: 'app-save-ecommerce',
	templateUrl: './save-ecommerce.component.html',
	styleUrls: ['./save-ecommerce.component.css']
})
export class SaveEcommerceComponent extends BaseComponent implements OnInit
{
	ecommerce:Ecommerce = GetEmpty.ecommerce();
	price_list: Price_List[] = [];
	price_type_list: Price_Type[] = [];
    	store_list:Store[] = [];

	ngOnInit(): void
	{
		this.subs.sink = this.route.paramMap.pipe
		(
			mergeMap((params:ParamMap)=>
			{
				let obs:Observable<Ecommerce> =  params.has('id') ? this.rest.ecommerce.get( params.get('id') as string )
					: of( GetEmpty.ecommerce() );

				return forkJoin
				({
					ecommerce: obs,
					price_list: this.rest.price_list.search({ sort_order: ['name_ASC'] }),
					stores: this.rest.store.search({ sort_order: ['name_ASC'] }),
					price_type_list: this.rest.price_type.search({ sort_order: ['name_ASC'] })
				});
			})
		)
		.subscribe((response)=>
		{
			this.ecommerce = response.ecommerce;
			this.store_list = response.stores.data;
			this.price_list = response.price_list.data;
			this.price_type_list = response.price_type_list.data;
		})
	}

	save()
	{
		this.is_loading = true;

		if( this.store_list.length == 1 )
		{
			this.ecommerce.store_id = this.store_list[0].id;
		}


		if( this.ecommerce.id	)
		{
			this.subs.sink	= this.rest.ecommerce.update( this.ecommerce ).subscribe((ecommerce)=>{
				this.is_loading = false;
				this.showSuccess('El comercio electronico se actualizo exitosamente');
				this.location.back();
			},(error)=>this.showError(error));
		}
		else
		{
			this.subs.sink	= this.rest.ecommerce.create( this.ecommerce ).subscribe((ecommerce)=>{
				this.is_loading = false;
				this.showSuccess('La comercio electronico se guardo exitosamente');
				this.location.back();
			},(error)=>this.showError(error));
		}
	}
}
